import React from "react";
import { Chip } from "@mui/material";
import { statusTone, tint } from "theme/tokens";

/**
 * One status pill for the whole app, so "Delivered" is the same green
 * everywhere. Unknown statuses render in neutral grey rather than being
 * hidden — an order with an unrecognised status still needs to be visible.
 */
export default function StatusChip({ status, label, tone, size = "small", sx }) {
  const color = tone || statusTone(status);
  return (
    <Chip
      size={size}
      label={label ?? status ?? "—"}
      sx={{
        bgcolor: tint(color, 0.12),
        color,
        fontWeight: 600,
        fontSize: "0.72rem",
        border: `1px solid ${tint(color, 0.28)}`,
        "& .MuiChip-label": { px: 1.1 },
        ...sx,
      }}
    />
  );
}
